import ApplicationApiError from "../../../../foundation/ApplicationApiError"
import { ReadRequest } from "~/backendApis/foundation/ReadRequest"
import { PaidPlanView } from "~/backendApis/viewModel"

interface Params {
  universalCorporationId: string
  paidPlanId: string
}

export class GetAppliablePaidPlanByIdReadRequest extends ReadRequest<PaidPlanView> {
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public get(): Promise<PaidPlanView | null> {
    return this.apiClient
      .get(this.makeEndpoint())
      .catch((e: ApplicationApiError) => {
        if (e.isNotFoundError()) {
          return null
        }
        throw e
      })
  }

  private makeEndpoint(): string {
    const { universalCorporationId, paidPlanId } = this.params
    return `/corporation_contract/corporation_member/${universalCorporationId}/applicable_paid_plan/show/${paidPlanId}`
  }
}
